import { useSelector } from "react-redux";
import { getIsOneLinkEnabled } from "src/features/marketing/imports/state";

export const useGetMarketingLinkTarget = () => {
  const isOneLinkEnabled = useSelector(getIsOneLinkEnabled);

  return isOneLinkEnabled ? "_self" : "_blank";
};
